// import { CachePersistor } from 'apollo-cache-persist';
import { InMemoryCache, } from 'apollo-cache-inmemory';
import * as i0 from "@angular/core";
var PersistorService = /** @class */ (function () {
    // persistor: CachePersistor<NormalizedCacheObject>;
    function PersistorService() {
        this.cache = new InMemoryCache({
            dataIdFromObject: function (o) { return o.id; },
        });
        // { dataIdFromObject: o => o.id }
        // this.persistor = new CachePersistor({
        //     cache: this.cache,
        //     storage: window.localStorage,
        // });
    }
    PersistorService.ngInjectableDef = i0.defineInjectable({ factory: function PersistorService_Factory() { return new PersistorService(); }, token: PersistorService, providedIn: "root" });
    return PersistorService;
}());
export { PersistorService };
